export default __webpack_public_path__ + "static/media/oxcim_free_plan_banner.f37a4cc1.png";